import { Component, Input, Output, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DniSectionComponent } from './dni-section/dni-section.component';
import { GeneralDocumentsListComponent } from './general-documents-list/general-documents-list.component';
import { ModalComponent } from '../../../../../shared/components/modal/modal.component';

@Component({
  selector: 'app-student-documents-tab',
  standalone: true,
  imports: [CommonModule, DniSectionComponent, GeneralDocumentsListComponent, ModalComponent],
  templateUrl: './student-documents-tab.component.html',
  styleUrl: './student-documents-tab.component.css'
})
export class StudentDocumentsTabComponent implements OnInit {
  @Input() userId!: number;
  @Input() user: any;
  @Output() userUpdated = new EventEmitter<void>();
  @Output() openDocumentModal = new EventEmitter<{isEditing: boolean, document?: any, formData?: any}>();
  @Output() closeDocumentModal = new EventEmitter<void>();
  @Output() openConfirmation = new EventEmitter<{question: string, action: () => void}>();
  
  @ViewChild('documentsListComponent') documentsListComponent!: GeneralDocumentsListComponent;

  ngOnInit(): void {
    if (!this.userId) {
      console.error('userId is required for StudentDocumentsTabComponent');
    }
  }

  onDniUpdated(): void {
    this.userUpdated.emit();
  }

  onOpenDocumentModal(data: {isEditing: boolean, document?: any, formData?: any}): void {
    this.openDocumentModal.emit(data);
  }

  onCloseDocumentModal(): void {
    this.closeDocumentModal.emit();
  }

  onOpenConfirmation(data: {question: string, action: () => void}): void {
    this.openConfirmation.emit(data);
  }
}
